import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/hoobuyData';

export default function LatestArticles() {
  return (
    <section id="artigos" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full border border-background-300 text-xs font-medium text-foreground-600 mb-4">
            Guia de Compras
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Artigos e Guias do Hoobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Confira nossos guias completos com conteúdo original e atualizado sobre o Hoobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-[10px] font-bold text-background-50">
                  {article.category}
                </span>
              </div>
              <div className="flex flex-col gap-2 p-4 md:p-5 flex-1">
                <span className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap">
                  {article.date}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 mt-auto whitespace-nowrap">
                  Ler Artigo Completo
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}